import { Component, Input } from '@angular/core';

@Component({
  selector: 'portfolio-intro',
  templateUrl: './portfolio-intro.component.html',
  styleUrls: ['./portfolio-intro.component.scss']
})

export class PortfolioIntroComponent {
  @Input() projectName: string;
  @Input() projectIntro: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/portfolio-intro/portfolio-intro.component.ts